import { fixedUi } from '@/i18n/fixedUi';

/** 复制模板时：仅当目标侧已有同名才追加「-副本」，并保证不超过 maxLen。 */

const COPY_SUFFIX = '-副本';

function normalizeBaseName(name) {
  return String(name || '').trim() || fixedUi('未命名模板');
}

function truncateWithSuffix(base, suffix, maxLen) {
  if (base.length + suffix.length <= maxLen) return `${base}${suffix}`;
  const keep = Math.max(0, maxLen - suffix.length);
  return `${base.slice(0, keep)}${suffix}`;
}

/**
 * @deprecated 请用 {@link resolveUniqueCopyTemplateName}：无冲突时保留原名。
 * 保留旧导出以免其它调用方立刻炸；行为改为与 resolveUnique 无 existingNames 时一致（不强制追加）。
 */
export function copyTemplateName(name, maxLen = 128) {
  return resolveUniqueCopyTemplateName(name, [], maxLen);
}

/**
 * @param {string} name 源模板名
 * @param {Iterable<string>|string[]} [existingNames] 目标 scope 下已有名称（大小写不敏感）
 * @param {number} [maxLen=128]
 * @returns {string}
 */
export function resolveUniqueCopyTemplateName(name, existingNames = [], maxLen = 128) {
  const base = normalizeBaseName(name);
  const limit = Number.isFinite(Number(maxLen)) && Number(maxLen) > 0 ? Number(maxLen) : 128;
  const taken = new Set(
    (Array.isArray(existingNames) ? existingNames : [...(existingNames || [])])
      .map((n) => String(n || '').trim().toLowerCase())
      .filter(Boolean),
  );
  const available = (candidate) => {
    const key = String(candidate || '').trim().toLowerCase();
    return key && !taken.has(key);
  };

  if (available(base)) {
    return base.length <= limit ? base : base.slice(0, limit);
  }

  let suffix = COPY_SUFFIX;
  let candidate = truncateWithSuffix(base, suffix, limit);
  if (available(candidate)) return candidate;

  for (let n = 2; n < 1000; n += 1) {
    suffix = `${COPY_SUFFIX}${n}`;
    candidate = truncateWithSuffix(base, suffix, limit);
    if (available(candidate)) return candidate;
  }
  return truncateWithSuffix(base, `${COPY_SUFFIX}${Date.now()}`, limit);
}
